<template>
  <div class="row">
    <div class="searchForm">
      <div class="col" style="width: 220px;flex-shrink: 0;" :class="[(active === 0 ? 'colActive' : '')]">
        <div class="label">{{ $t('util.cfrq') }}</div>
        <el-date-picker style="width: 100%;height: 100%" class="noborder ipt" :picker-options="pickOption" v-model="bookDate" @focus="()=>{active=0}" @blur="()=>{active=''}" />
      </div>
      <div class="horBorder" />
      <div class="col" style="width: 360px;flex-shrink: 0;" :class="[(active === 1 ? 'colActive' : '')]">
        <div class="label">{{ $t('util.xcts') }}</div>
        <el-select v-model="tourDay" placeholder="不限" style="width: 100%;height: 100%" class="noborder ipt" @focus="()=>{active=1}" @blur="()=>{active=''}" clearable>
          <el-option label="1天" value="1" />
          <el-option label="2天" value="2" />
          <el-option label="3天" value="3" />
          <el-option label="4天" value="4" />
          <el-option label="5天" value="5" />
          <el-option label="6天" value="6" />
          <el-option label="7天" value="7" />
          <el-option label="8天" value="8" />
        </el-select>
      </div>
      <div class="horBorder" />
      <div class="col" :class="[(active === 2 ? 'colActive' : '')]">
        <div class="label">{{$t('util.mddgjz')}}</div>
        <input v-model="kw" type="text" class="ipt" :placeholder="$t('util.mddgjz')" @focus="()=>{active=2}" @blur="()=>{active=''}" />
      </div>
      <div v-if="false" class="col" :class="[(active === 2 ? 'colActive' : '')]">
        <div class="label">{{ $t('util.cfd') }}</div>
        <el-select v-model="starPoint" placeholder="不限" style="width: 100%;height: 100%" class="noborder ipt" @focus="()=>{active=2}" @blur="()=>{active=''}" clearable>
          <el-option label="1天" value="1" />
        </el-select>
      </div>
      <div v-if="false" class="col" :class="[(active === 3 ? 'colActive' : '')]">
        <div class="label">{{ $t('util.mdd') }}</div>
        <el-select v-model="province" placeholder="不限" style="width: 100%;height: 100%" class="noborder ipt" @focus="()=>{active=3}" @blur="()=>{active=''}" clearable>
          <el-option label="1天" value="1" />
        </el-select>
      </div>
    </div>
    <el-button type="success" plain size="medium" class="btn" @click="search">{{ $t('util.ss') }}</el-button>
  </div>
</template>

<script>
import dayjs from 'dayjs'

export default {
  name: 'SearchBoxTour',
  data () {
    return {
      kw: '',
      active: '',
      tourDay: '',
      province: '',
      starPoint: '',
      bookDate: dayjs().add(1, 'day').toDate()
    }
  },
  props: {
    pickOption: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  methods: {
    search () {
      this.$router.push({
        path: '/tour/list',
        query: {
          kw: this.kw,
          tourDay: this.tourDay,
          bookDate: dayjs(this.bookDate).format('YYYY-MM-DD')
        }
      })
      console.log(123)
    }
  }
}
</script>

<style scoped lang="scss">
@import "../searchBox.scss";
</style>



// WEBPACK FOOTER //
// src/components/global/searchBox/components/tour.vue